import React from 'react';
import LexicalEditorWrapper from './components/LexicalEditorWrapper';

export default function RichTextEditor({
  id,
  className,
  onChange = () => {},
  onBlur,
  value,
  readOnly = false,
  topBarComponent = null,
  height,
}) {
  return  (
    <div className={className}>
      <LexicalEditorWrapper
        id={id}
        topBarComponent={topBarComponent}
        onChange={onChange}
        onBlur={onBlur}
        readOnly={readOnly}
        value={value}
        height={height}
      />
    </div>
  );
}
